module.exports = __webpack_public_path__ + "static/media/aLINK-logo.b46d667c.png";